export const SIGN_OFF_NEVER = 0,
  SIGN_OFF_RUNNING = 1,
  SIGN_OFF_FINISH = 2,
  SIGN_OFF_UPDATE = 3;